import {merge, fromEvent, Subject} from "rxjs";
import {filter, tap} from "rxjs/operators";
import {ajax} from "rxjs/ajax";

type TwGlobal = {
  ajaxUrl: string;
  cartUrl: string;
};

type Response = {
  success: boolean;
  message: string;
  data: {
    url: string;
    error: string;
  };
};

declare const twGlobal: TwGlobal;

class SubmitHandler {
  private formData: FormData;
  private radioField = ["colore", "fronteoretro", "layout", "lavorazione"];

  constructor(
      private $wrapper: HTMLElement | null = null,
      private $form: HTMLFormElement | null = null,
      private $tracker: HTMLElement | null = null
  ) {
    this.init();
  }

  init() {
    this.formData = new FormData();
    // const uploadFile$ = of(this.uploadFile());
    const $notification = this.$tracker.querySelector(
        ".form-tracker-notification"
    ) as HTMLElement;

    fromEvent(this.$form, "submit")
        .pipe(tap((e: Event) => e.preventDefault()))
        .subscribe(() => {
          this.handleDisabledInputs(true);
          this.uploadFile($notification);
        });

    fromEvent(this.$form, "fileUploaded").subscribe(() => {
      this.getRadioChoices();
      this.getSelectChoice();
      this.getInputField();
      this.getFileName();
      this.submit($notification);
    });
  }

  getFileName() {
    const $fileName = this.$form.querySelector(
        ".upload-file-name"
    ) as HTMLElement;
    const value = $fileName && $fileName.innerText;
    value && this.formData.append("file-name", value);
    return this;
  }

  getRadioChoices() {
    this.radioField.forEach((field) => {
      const [$selectedRadio] = Array.from(this.$form.querySelectorAll<HTMLInputElement>(`input[name="${field}"]`))
          .filter((item) => item.checked);
      if (!$selectedRadio) return false;
      this.formData.append(field, $selectedRadio.id);
      console.log({field, $selectedRadio, id: $selectedRadio.id});
      debugger;
    });

    return this;
  }

  getSelectChoice() {
    const rilegatura = this.$form.querySelector(
        `select[name="rilegature"]`
    ) as HTMLSelectElement;
    if (rilegatura) {
      const $selectedOption = rilegatura.options[rilegatura.selectedIndex];
      const {value} = $selectedOption.dataset;
      this.formData.append("rilegatura", value);
    }
  }

  getInputField() {
    Array.from(
        this.$form.querySelectorAll(".tw-print-input") as ArrayLike<HTMLElement>
    ).forEach(($field) => {
      this.formData.append(
          $field.getAttribute("name") as string,
          ($field as HTMLFormElement).value
      );
    });

    Array.from(
        this.$form.querySelectorAll(
            ".tw-print-textarea"
        ) as ArrayLike<HTMLElement>
    ).forEach(($field) => {
      this.formData.append(
          $field.getAttribute("name") as string,
          ($field as HTMLTextAreaElement).value
      );
    });
  }

  uploadFile($notification: HTMLElement) {
    const formData = new FormData();
    const $file = this.$form.querySelector<HTMLInputElement>(`input[name="tw-form-upload"]`);
    const file = $file?.files?.[0];

    if (!file) return;

    const $addToCartButton = this.$tracker.querySelector<HTMLButtonElement>(".tw-print-cart-button");
    const $percentageText = document.querySelector<HTMLElement>(".tw_form_loading__loading-text .text");
    const $buttonText = $addToCartButton.querySelector<HTMLElement>(".text");
    const $spinningIcon = $addToCartButton.querySelector<HTMLElement>(".spinning-icon");

    const progressSubscriber$: Subject<ProgressEvent> = new Subject();
    formData.append("file", file);
    formData.append("action", "twUploadFile");

    progressSubscriber$
        .pipe(
            filter(({loaded, total}) => loaded > 0 && total > 1)
        )
        .subscribe(({loaded, total}) => {
          const percentage = loaded / total * 100;
          $buttonText.innerText = `Caricamento al ${percentage.toFixed(0)}%`;
          $percentageText.innerText = `${percentage.toFixed(0)}%`;
        })

    ajax({
      url: twGlobal.ajaxUrl,
      method: "POST",
      body: formData,
      progressSubscriber: progressSubscriber$
    }).subscribe(({response}) => {
      const isDone = !!(response as Response)?.success;

      $addToCartButton.disabled = !isDone;

      if (isDone) {
        this.formData.append("file-url", (response as Response).data.url);
        const event = new Event("fileUploaded");
        this.$form.dispatchEvent(event);
        this.handleDisabledInputs(false);

        $buttonText.innerText = $buttonText.dataset.initialText;
        $percentageText.innerText = '';
        $spinningIcon && $spinningIcon.classList.remove("--visible");
        return;
      }

      $notification.innerHTML = (response as Response)?.data.error;
      $notification.classList.add("--visible");

    });
  }

  submit($notification: HTMLElement) {
    this.formData.append("action", "twAddPrintToCart");

    ajax({
      url: twGlobal.ajaxUrl,
      method: "POST",
      body: this.formData,
    }).subscribe((response) => {
      if ((response.response as Response)?.success) {
        window.location.href = twGlobal.cartUrl;
      } else {
        $notification.innerHTML = (response.response as Response)?.message;
        $notification.classList.add("--visible");
      }
    });
  }

  handleDisabledInputs(inputsAreDisabled?: boolean) {
    if (this.$form) {
      const $loadingDiv = this.$wrapper.querySelector(".tw_form_loading");
      $loadingDiv &&
      $loadingDiv.classList[inputsAreDisabled ? "add" : "remove"](
          "--visible"
      );

      const $addToCartButton = this.$tracker.querySelector(
          ".tw-print-cart-button"
      ) as HTMLButtonElement;

      const $spinningIcon = $addToCartButton.querySelector(
          ".spinning-icon"
      ) as HTMLElement;

      $addToCartButton.disabled = inputsAreDisabled;
      $spinningIcon &&
      $spinningIcon.classList[inputsAreDisabled ? "add" : "remove"](
          "--visible"
      );
    }
  }
}

fromEvent(window, "DOMContentLoaded").subscribe(() => {
  const $wrapper = document.querySelector(
      "#tw-print-form-wrapper"
  ) as HTMLElement;
  const $form = document.querySelector("#tw-print-form") as HTMLFormElement;
  const $tracker = document.querySelector("#tw_form_tracker") as HTMLElement;
  if ($form && $wrapper) new SubmitHandler($wrapper, $form, $tracker);
});
